<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-12 pt-3 pb-3 pl-4">
        <h3><i class="fas fa-road"></i> Tipos de Finalizações Atendimento</h3>
      </div>
    </div>
    <TiposFinalizacaoAdd v-if="showAdd" ref="TiposFinalizacaoAdd" v-on:Back="onBack" />
    <TiposFinalizacaoList v-else ref="TiposFinalizacaoList" v-on:New="onNew" v-on:Edit="onEdit"/>
  </div>
</template>
<script>
import Tools from '@/components/tools/Tools.js'
import TiposFinalizacaoAdd from './components/add/TiposFinalizacaoAdd.vue'
import TiposFinalizacaoList from './components/list/TiposFinalizacaoList.vue'

export default {
  name: 'TiposFinalizacao',
  data () {
    return {
      showAdd: false
    }
  },
  components: {
    TiposFinalizacaoAdd,
    TiposFinalizacaoList
  },
  mounted () {
  },
  methods: {
    onLoad () {},
    onNew () {
      this.showAdd = true
    },
    onEdit (obj) {
      this.showAdd = true
      this.$nextTick(() => {
        this.$refs.TiposFinalizacaoAdd.onEdit(obj)
      })
    },
    onBack () {
      this.showAdd = false
    }
  },
  beforeDestroy () {
    this.$eventHub.off('Filter')
    Tools.MinimizedASidebar()
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/parametros_atendimento/TiposFinalizacao/tipoFinalizacao.vue